import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SYSTEM_CHAT_AUTHOR_ID, } from '@long-game/common';
import { withGame } from '@long-game/game-client';
export const PlayerName = withGame(function PlayerName({ gameSuite, playerId, disableYou = false, }) {
    const player = playerId && playerId !== SYSTEM_CHAT_AUTHOR_ID
        ? gameSuite.getPlayer(playerId)
        : null;
    const isMe = playerId === gameSuite.playerId;
    if (isMe && !disableYou) {
        return _jsx(_Fragment, { children: "You" });
    }
    if (playerId === SYSTEM_CHAT_AUTHOR_ID) {
        return _jsx(_Fragment, { children: "Game" });
    }
    return _jsx(_Fragment, { children: player?.displayName ?? 'Anonymous' });
});
//# sourceMappingURL=PlayerName.js.map